var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 103,
	"./layouts/card/style.module.scss": 103,
	"./layouts/components/breadcrumbs": 136,
	"./layouts/components/breadcrumbs/": 136,
	"./layouts/components/breadcrumbs/index": 136,
	"./layouts/components/breadcrumbs/index.tsx": 136,
	"./layouts/components/breadcrumbs/style.module": 193,
	"./layouts/components/breadcrumbs/style.module.scss": 193,
	"./layouts/components/container": 48,
	"./layouts/components/container/": 48,
	"./layouts/components/container/index": 48,
	"./layouts/components/container/index.tsx": 48,
	"./layouts/components/container/style.module": 138,
	"./layouts/components/container/style.module.scss": 138,
	"./layouts/components/footer": 137,
	"./layouts/components/footer/": 137,
	"./layouts/components/footer/index": 137,
	"./layouts/components/footer/index.tsx": 137,
	"./layouts/components/footer/style.module": 93,
	"./layouts/components/footer/style.module.scss": 93,
	"./layouts/components/loading_indicator": 55,
	"./layouts/components/loading_indicator/": 55,
	"./layouts/components/loading_indicator/index": 55,
	"./layouts/components/loading_indicator/index.tsx": 55,
	"./layouts/components/nav_bar": 102,
	"./layouts/components/nav_bar/": 102,
	"./layouts/components/nav_bar/index": 102,
	"./layouts/components/nav_bar/index.tsx": 102,
	"./layouts/components/nav_bar/standalone": 367,
	"./layouts/components/nav_bar/standalone.tsx": 367,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 91,
	"./layouts/components/notice_banner/": 91,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 194,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 194,
	"./layouts/components/notice_banner/index": 91,
	"./layouts/components/notice_banner/index.tsx": 91,
	"./layouts/components/notice_banner/standalone": 368,
	"./layouts/components/notice_banner/standalone.tsx": 368,
	"./layouts/components/notice_banner/style.module": 195,
	"./layouts/components/notice_banner/style.module.scss": 195,
	"./layouts/page": 107,
	"./layouts/page/": 107,
	"./layouts/page/index": 107,
	"./layouts/page/index.tsx": 107,
	"./layouts/page/style.module": 94,
	"./layouts/page/style.module.scss": 94,
	"./layouts/types": 369,
	"./layouts/types.ts": 369,
	"./marketing/pages/home/toefl": 1573,
	"./marketing/pages/home/toefl/": 1573,
	"./marketing/pages/home/toefl/index": 1573,
	"./marketing/pages/home/toefl/index.tsx": 1573,
	"./marketing/pages/home/toefl/sections/ai": 1175,
	"./marketing/pages/home/toefl/sections/ai/": 1175,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1806,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1806,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1807,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1807,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1808,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1808,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1809,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1809,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1810,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1810,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1811,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1811,
	"./marketing/pages/home/toefl/sections/ai/index": 1175,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1175,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1812,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1812,
	"./marketing/pages/home/toefl/sections/apps": 1176,
	"./marketing/pages/home/toefl/sections/apps/": 1176,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1813,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1813,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1814,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1814,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1815,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1815,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1816,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1816,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1817,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1817,
	"./marketing/pages/home/toefl/sections/apps/index": 1176,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1176,
	"./marketing/pages/home/toefl/sections/features": 1177,
	"./marketing/pages/home/toefl/sections/features/": 1177,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1818,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1818,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1819,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1819,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1820,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1820,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1821,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1821,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1822,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1822,
	"./marketing/pages/home/toefl/sections/features/index": 1177,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1177,
	"./marketing/pages/home/toefl/sections/official_questions": 1181,
	"./marketing/pages/home/toefl/sections/official_questions/": 1181,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1831,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1831,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1181,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1181,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 690,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 690,
	"./marketing/pages/home/toefl/sections/value_props": 1178,
	"./marketing/pages/home/toefl/sections/value_props/": 1178,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1823,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1823,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1824,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1824,
	"./marketing/pages/home/toefl/sections/value_props/index": 1178,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1178,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2224,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2224,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1179,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1179,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1825,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1825,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1826,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1826,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1827,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1827,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1828,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1828,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1829,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1829,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1179,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1179,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 689,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 689,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1180,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1180,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1830,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1830,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1180,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1180,
	"./marketing/pages/home/toefl/style.module": 1832,
	"./marketing/pages/home/toefl/style.module.scss": 1832,
	"./marketing/pages/plans/toefl": 1574,
	"./marketing/pages/plans/toefl/": 1574,
	"./marketing/pages/plans/toefl/index": 1574,
	"./marketing/pages/plans/toefl/index.tsx": 1574,
	"./marketing/pages/plans/toefl/sections/testimonials": 1182,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1182,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1833,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1833,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1834,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1834,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1182,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2563;